import React, {useState} from "react";
import QrReader from "react-qr-scanner";
import {
    Box,
    Button,
    Card, CardBody, CardFooter,
    CardHeader,
    Form,
    FormField,
    Grid,
    Heading, Image,
    Layer,
    RangeInput,
    Text,
    TextInput
} from "grommet";
import { NumberInput } from 'grommet-controls';

import {Favorite, Scan, ShareOption} from "grommet-icons";
import Html5QrcodePlugin from "../plugin/Html5QrcodePlugin";
import api from "../utils/api";
import {getUserId} from "../utils/token";

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import ConfirmationDialog from "./ConfirmationDialog"; // Import css

const QRScanner = () => {
    const [showScanner, setShowScanner] = useState(true);
    const [scannedEmail, setScannedEmail] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [points, setPoints] = useState(0);

    const handleScan = (data) => {
        if (data) {
            setScannedEmail(data);
            //setFidelityCard(fidelityCard);
            //setScannedEmail("matteodome@gmail.com");
            //setShowScanner(true);
            setShowForm(true);
        }

    };

    const handleCloseScanner = () => {
        setShowScanner(false);
    };

    const handleCloseForm = () => {
        setShowForm(false);
        //setShowScanner(false);
    };
    const showDialog = () => {
        ConfirmationDialog(scannedEmail, points);
    };
    const handleSubmit = (event) => {
        event.preventDefault();

        // Submit the form with the scanned email and point value
        console.log(`Email: ${scannedEmail} Points: ${points}`);
        showDialog();

        /*

        api.post(process.env.REACT_APP_BASE_API_URL + 'api/transactions',
            {
                "amount": parseInt(points),
                "fidelityCard": fidelityCard
            }
        ).then((response) => {

        }).catch(error => {
            console.error(error);
        });
        handleCloseForm();

        */
    };

    const onNewScanResult = (decodedText, decodedResult) => {
        // handle decoded results here
    };

    return (
        <Grid row="large" columns="large" gap="small" pad={{bottom: "small"}}>
                <Card background="light-1" border="dark" height="600px">
                    <CardHeader pad="medium">
                        <Text weight={"bold"} color={"brand"}>
                            Azioni Operatore
                        </Text>
                    </CardHeader>
                    <CardBody pad="medium" justify="around">

                            {showScanner ? (
                                <>
                                    <Box height={"500px"}>

                                        {/*<QrReader
                                            facingMode="environment"
                                            delay={150}
                                            onError={(error) => console.log(error)}
                                            onScan={handleScan}
                                            style={{width: "100%"}}
                                        />*/}
                                        <Html5QrcodePlugin
                                            fps={30}
                                            qrbox={250}
                                            disableFlip={false}
                                            qrCodeSuccessCallback={handleScan}
                                        />

                                    </Box>
                                    {/*<Button label="Chiudi" onClick={handleCloseScanner}/>*/}
                                </>
                            ) : (
                                <Button label="Scansiona QR Code" icon={<Scan color="red"/>}
                                        onClick={() => setShowScanner(true)}/>
                            )}

                            {showForm && (
                                <Layer onEsc={() => setShowForm(false)}>
                                    <Box pad="medium">
                                        <Heading level={3}>Aggiungi punti</Heading>
                                        <Form onSubmit={handleSubmit}>

                                            <FormField name="email" label="Email" htmlFor="email-input" required>
                                                <TextInput id="email-input" type="text" value={scannedEmail}
                                                           name="email" disabled/>
                                            </FormField>
                                            <FormField label="Points" name="points" htmlFor="points-input">
                                                <NumberInput
                                                    id="points-input"
                                                    name="points"
                                                    min={0}
                                                    max={300}
                                                    value={points}
                                                    onChange={(event) => setPoints(event.target.value)}
                                                />

                                                {/*
                                                <RangeInput
                                                    id="points-input"
                                                    name="points"
                                                    min={0}
                                                    max={50}
                                                    value={points}
                                                    onChange={(event) => setPoints(event.target.value)}
                                                />
                                                <p> {points} </p>
                                                */}


                                            </FormField>

                                            <Box direction="row" justify="end" margin={{top: "medium"}}>
                                                <Button label="5 Punti" margin={{left: "small"}}
                                                        onClick={() => {
                                                            setPoints( 5 );
                                                        }}
                                                />
                                                <Button label="10 Punti" margin={{left: "small"}}
                                                        onClick={() => {
                                                            setPoints( 10 );
                                                        }}
                                                />
                                                <Button label="15 Punti" margin={{left: "small"}}
                                                        onClick={() => {
                                                            setPoints( 15 );
                                                        }}
                                                />
                                            </Box>
                                            <Box direction="row" justify="end" margin={{top: "medium"}}>
                                                <Button label="20 Punti" margin={{left: "small"}}
                                                        onClick={() => {
                                                            setPoints( 20 );
                                                        }}
                                                />
                                                <Button label="25 Punti" margin={{left: "small"}}
                                                        onClick={() => {
                                                            setPoints( 25 );
                                                        }}
                                                />
                                                <Button label="30 Punti" margin={{left: "small"}}
                                                        onClick={() => {
                                                            setPoints( 30 );
                                                        }}
                                                />
                                            </Box>
                                            <Box direction="row" justify="end" margin={{top: "medium"}}>
                                                <Button type="submit" label="Aggiungi Punti" primary/>
                                                <Button label="Esci" margin={{left: "small"}}
                                                        onClick={handleCloseForm}/>
                                            </Box>
                                        </Form>
                                    </Box>
                                </Layer>
                            )}
                    </CardBody>
                </Card>
        </Grid>

    );
};

export default QRScanner;
